import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";

const OtherfestiveGifts = () => {
    const CTAContent = [
        {
          pageName: "Other Festive Gifts",
          paragraphitalic: "Celebrate Every Occasion, Big or Small",
          paragraphText:
                "India is a land of celebrations, and every festival is an opportunity to connect and engage. Whether it’s Holi, Raksha Bandhan, or a regional festival, we’ve got unique gifting solutions for all occasions.",
          ContactFormName: "Other Festive Gifts",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "Vibrant Holi Hampers",
          parapgraphItalic: "Celebrate the Colours of Joy!",
          sectionparagraphText: (
            <>
              <p>
                Curated hampers that add vibrance and fun to every Holi celebration. 
              </p>
              <p>
                This Holi, let your gifts spread colours and joy! Our vibrant Holi hampers are packed with everything you need to make the festival memorable. From organic gulal to delectable treats, these hampers are perfect for celebrating the festival of colours with loved ones, employees, or clients. 
              </p>
            </>
          ),
          ImgSrc: "../assests/images/other-festive/Vibrant Holi Hampers.jpg",
          
        },
    
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Raksha Bandhan Gift Sets",
          parapgraphItalic: "Celebrate the Bond of Love and Protection",
          sectionparagraphText: (
            <>
              <p>
                Thoughtfully crafted gift sets for brothers and sisters to cherish.
              </p>
              <p>
                Raksha Bandhan is all about celebrating the unique bond of siblings. Our specially curated gift sets are perfect for expressing love and appreciation. From personalized rakhis to delightful treats, these sets are designed to make the occasion even more special.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/other-festive/Raksha Bandhan Gift Sets.jpg",
          categoryHeadingLeftSide: "Features That Bond",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/other-festive/Customized Rakhis.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Customized Rakhis</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/other-festive/Festive Sweets.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Festive Sweets</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/other-festive/Elegant Packaging.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Elegant Packaging</b> <br></br>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
      const noGapContent = [
        {
          RightImgNogap: "../assests/images/other-festive/Features That Add Colour.jpg",
          NogapHeading: "Features That Add Colour",
          Heading: [
            {
              ListHeading: "Organic Colours",
              ListParagraph:
                "Safe and skin-friendly gulal in vibrant shades for carefree celebrations.",
            },
            {
              ListHeading: "Festive Treats",
              ListParagraph:
                "Include gujiyas, namkeen, and refreshing drinks like thandai.",
            },
            {
              ListHeading: "Customizable Additions",
              ListParagraph:
                "Add branded pouches, water guns, or personalized messages for a unique touch.",
            },
          ],
        },
        {
          RightImgNogap: "../assests/images/other-festive/Regional Festive Goodies.jpg",
          NogapHeading: "Regional Festive Goodies",
          paragraphItalic: "Celebrate India’s Diversity with Unique Festive Flavors",
          paragraphDetail: (
            <>
              <p>
                Savor the essence of every region with our curated festive goodies.
              </p>
              <p>
                India’s festivals are as diverse as its culture, and so are the flavours that come with them. Our regional festive goodies bring authentic tastes from across the country to your celebrations. Whether it’s Mysore Pak from the South, Bengali Sandesh, or Punjabi Atta Laddoos, these treats are a true celebration of India’s culinary heritage. 
              </p>
            </>
          ),
    
          NogapSubheading: "Features That Celebrate Tradition",
          Categories: [
            {
              ServiceImg: "../assests/images/other-festive/Authentic Regional Delicacies.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Authentic Regional Delicacies</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/other-festive/Wide Variety.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Wide Variety</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/other-festive/Festive Packaging.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Festive Packaging</b>
                  </p>
                </>
              ),
            },
          ],
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/other-festive/Milestone Recognition.jpg",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>Appreciate dedication and achievements.</p>
              <p>
                Show appreciation for the hard work and dedication that goes into
                every achievement.
              </p>
              <p>
                Milestones such as work anniversaries, project completions, and
                promotions deserve to be celebrated. At eYantra, we provide a range
                of premium milestone gifts that are as unique as the achievements.
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/other-festive/Personalized Awards.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/other-festive/Luxury Gift Hamper.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/other-festive/Luxury Gift Hampers.png",
              ServiceText: (
                <>
                  <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
                </>
              ),
            },
          ],
        },
      ];
    
  return (
    <>
      <Helmet>
        <title>eYantra Festive & Corporate Gifting</title>
        <meta name="description" content="eYantra offers festive gifting, bulk gifting, employee gifts, branded merchandise, joining kits, and welcome kits for smart corporate gifting solutions."/>
        <meta name="keywords" content="eyantra, festive gifting, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits,bulk gifting, employee gifts "/>
        </Helmet>
        <div className="p-0 m-2" >
      <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Let’s make every celebration unforgettable – one perfect gift at a time! 
      </p>
    </>
  );
};

export default OtherfestiveGifts;
